import { StyleSheet, Text, View, Image, SafeAreaView } from "react-native";
import React, { useEffect, useState } from "react";
import { SpecificCategoryScreenProps } from "../DiscountStack";

import { categoriesList } from "../../../../components/DiscountsPerCategoryCard/categories";
import CategoryHeader from "./CategoryHeader";
import ExclusiveDiscounts, {
  Filters,
} from "../../../../components/ExclusiveDiscounts";
import CategoryFilters from "./CategoryFilters";
const SpecificCategory = ({
  route,
  navigation,
}: SpecificCategoryScreenProps) => {
  const [sort, setSort] = useState<"new" | "popular">("popular");
  const [filters, setFilters] = useState<Filters>({
    category: route.params.category,
    discountType: "Todas",
    region: "Todas",
  });

  useEffect(() => {
    setFilters({ ...filters, category: route.params.category });
  }, [route.params.category]);
  const categoryData = categoriesList.find(
    (c) => c.category === filters.category
  );
  if (!categoryData) return null;
  return (
    <SafeAreaView style={styles.root}>
      <CategoryHeader category={categoryData} />
      <CategoryFilters
        filters={filters}
        sort={sort}
        setFilters={setFilters}
        setSort={setSort}
      />

      <ExclusiveDiscounts specific={{ sort, filters }} />
    </SafeAreaView>
  );
};

export default SpecificCategory;

const styles = StyleSheet.create({
  root: {
    flex: 1,
    marginBottom: 70,
  },
});
